import { useMutation } from '@tanstack/react-query';

import { searchEnterprisesAndBrands } from 'apis/enterprise/api';
import { searchVenues } from 'apis/restaurant-api/merchant-admin/venue-search/api';

import { isValidSearchQuery } from '../utils';

export const useSearch = () => {
  const {
    data: searchResults = [],
    mutate,
    isLoading: isSearching,
  } = useMutation(async (searchValue: string) => {
    if (!isValidSearchQuery(searchValue)) {
      return Promise.resolve([]);
    }
    const [venues, enterprise] = await Promise.all([
      searchVenues(searchValue),
      searchEnterprisesAndBrands(searchValue),
    ]);
    const enterprises = enterprise ? enterprise.enterprises : [];
    const brands = enterprise ? enterprise.brands : [];
    return [...enterprises, ...brands, ...venues];
  });

  return { searchResults, mutate, isSearching };
};
